import { Component, Input, OnChanges, OnInit, } from '@angular/core';
import { faBookReader } from '@fortawesome/pro-solid-svg-icons';
import {
  CustomShowcaseMetadataInfo,
  ExtractedSingleShowcaseResource,
  SHOWCASES_PARAMS,
  ShowcasesEntity,
  ShowcasesTypes,
} from 'search/full-card/models/showcases';
import { EntityTypes, } from '../../../../../../entity/models/entity';

@Component({
  selector: 'app-single-showcase-view',
  templateUrl: './single-showcase-view.component.html',
  styleUrls: ['./single-showcase-view.component.scss'],
})
export class SingleShowcaseViewComponent implements OnInit, OnChanges {
  @Input() public resources: ExtractedSingleShowcaseResource[];
  @Input() public isLoading: boolean;
  @Input() public totalCount: number;
  @Input() public showcaseId: string;
  @Input() public identifier: string;
  @Input() public showcaseType: string;
  @Input() public entity: ShowcasesEntity;
  @Input() public metadata: CustomShowcaseMetadataInfo;
  public resourcePerPage: number;
  public isSeeAllButtonVisible: boolean;
  public showMoreResourcesCount: number;
  public isAutoGeneratedShowcase: boolean;
  public showcasesTypes = ShowcasesTypes;
  public INSTANCE = EntityTypes.INSTANCE;
  public FORMAT_GROUP = EntityTypes.FORMAT_GROUP;
  public readonly customShowcaseIcon = faBookReader;

  constructor() {}

  public ngOnInit() {
    this.isAutoGeneratedShowcase = ![
      ShowcasesTypes.RESOURCES,
      ShowcasesTypes.CONTRIBUTORS,
      ShowcasesTypes.TOPICS,
      ShowcasesTypes.CUSTOM,
    ].some((type) => this.showcaseType === type);
  }

  public ngOnChanges() {
    if (this.entity.entityType === EntityTypes.INSTANCE
      || this.entity.entityType === EntityTypes.FORMAT_GROUP
      || this.showcaseType === ShowcasesTypes.CUSTOM) {
      this.isSeeAllButtonVisible = this.totalCount > SHOWCASES_PARAMS.RESOURCES_PER_SHOWCASE_RESOURCE_PAGE;
      this.showMoreResourcesCount = this.totalCount - SHOWCASES_PARAMS.RESOURCES_PER_SHOWCASE_RESOURCE_PAGE + 1;
      this.resourcePerPage = SHOWCASES_PARAMS.RESOURCES_PER_SHOWCASE_RESOURCE_PAGE;
    } else {
      this.isSeeAllButtonVisible = this.totalCount > SHOWCASES_PARAMS.RESOURCES_PER_SHOWCASE_PAGE;
      this.showMoreResourcesCount = this.totalCount - SHOWCASES_PARAMS.RESOURCES_PER_SHOWCASE_PAGE + 1;
      this.resourcePerPage = SHOWCASES_PARAMS.RESOURCES_PER_SHOWCASE_PAGE;
    }

    if (this.showcaseType === this.showcasesTypes.CUSTOM && this.resources.length > SHOWCASES_PARAMS.RESOURCES_PER_SHOWCASE_RESOURCE_PAGE) {
      this.resources.length = SHOWCASES_PARAMS.RESOURCES_PER_SHOWCASE_RESOURCE_PAGE;
    }
  }
}
